import { create } from 'zustand';

interface LicensesState {
  isModalOpen: boolean;
  editingLicenseId: string | null;
  actions: {
    openCreateModal: () => void;
    openEditModal: (licenseId: string) => void;
    closeModal: () => void;
  };
}

export const useLicensesStore = create<LicensesState>((set) => ({
  isModalOpen: false,
  editingLicenseId: null,
  actions: {
    openCreateModal: () => set({ isModalOpen: true, editingLicenseId: null }),
    openEditModal: (licenseId) => set({ isModalOpen: true, editingLicenseId: licenseId }),
    closeModal: () => set({ isModalOpen: false, editingLicenseId: null }),
  },
}));

export const useLicensesActions = () => useLicensesStore((state) => state.actions);
